<template>
    <div class="footer-steps">
        <ul class="left" v-if="!route.meta.hideStage">
            <li><span class="text-uppercase stage-title">Stage</span></li>
<router-link :to="{name: 'Your Dashboard'}" v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <li :class="[isExactActive && 'router-link-exact-active']">
                    <a :href="href" class="stage" @click="navigate">1</a>
                </li>
            </router-link>
            <router-link :to="{name: 'Your Profile', params: { scheme: currentScheme }}" v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <li :class="[isExactActive && 'router-link-exact-active']">
                    <a :href="href" class="stage" @click="navigate">2</a>
                </li>
            </router-link>
            <router-link :to="{name: 'Shortlist', params: { scheme: currentScheme }}" v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <li :class="[isExactActive && 'router-link-exact-active']">
                    <a v-if="yourProfileCompleted || isComparisonOrBeyond" :href="href" class="stage" @click="navigate">3</a>
                    <span v-else class="stage disabled">3</span>
                </li>
            </router-link>
            <router-link :to="{name: 'Car Comparison', params: { scheme: currentScheme }}" v-slot="{ href, navigate, isActive, isExactActive }" custom>
                <li :class="[(isExactActive || isConfigureStep) && 'router-link-exact-active']">
                    <a v-if="yourProfileCompleted" :href="href" class="stage" @click="navigate">4</a>
                    <span v-else class="stage disabled">4</span>
                </li>
            </router-link>
            <router-link v-if="(selectedQuote.scheme === 'ecoamaps' || isEcoAmapsOrderStep) && selectedQuote.quoteID" :class="{'disabled': !selectedQuote}" :event="selectedQuote ? 'click' : ''" :to="{ name: 'ECO / AMAPS Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }" v-slot="{ href, route, navigate, isActive, isExactActive }" custom>
                <li :class="[(isActive || isExactActive || isEcoAmapsOrderStep) && 'router-link-exact-active']">
                    <a v-if="yourProfileCompleted && selectedQuote" :href="href" class="stage" @click="navigate">5</a>
                    <span v-else class="stage disabled">5</span>
                </li>
            </router-link>
            <router-link v-else-if="(selectedQuote.scheme === 'salsac' || isSalarySacrificeOrderStep) && selectedQuote.quoteID" :class="{'disabled': !selectedQuote}" :event="selectedQuote ? 'click' : ''" :to="{name: 'Salary Sacrifice Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }" v-slot="{ href, route, navigate, isActive, isExactActive }" custom>
                <li :class="[(isActive || isExactActive || isSalarySacrificeOrderStep) && 'router-link-exact-active']">
                    <a v-if="yourProfileCompleted && selectedQuote" :href="href" class="stage" @click="navigate">5</a>
                    <span v-else class="stage disabled">5</span>
                </li>
            </router-link>
            <router-link v-else-if="(selectedQuote.scheme === 'bch' || isBchOrderStep) && selectedQuote.quoteID" :class="{'disabled': !selectedQuote}" :event="selectedQuote ? 'click' : ''" :to="{name: 'Business Contract Hire Personal Details', params: { quoteId: (selectedQuote ? selectedQuote.quoteID : '') } }" v-slot="{ href, route, navigate, isActive, isExactActive }" custom>
                <li :class="[(isActive || isExactActive || isBchOrderStep) && 'router-link-exact-active']">
                    <a v-if="yourProfileCompleted && selectedQuote" :href="href" class="stage" @click="navigate">5</a>
                    <span v-else class="stage disabled">5</span>
                </li>
            </router-link>
            <li v-else>
                <a href="#" class="stage disabled" disabled="true">5</a>
            </li>
        </ul>
    </div>
</template>

<script type="text/javascript">

import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
    props: ['selectedQuote','yourProfileCompleted','adminPortalData'],

    setup () {
        const route = useRoute();
        const routePath = computed(() => {
            return useRoute().fullPath;
        })
        return { route, routePath }
    },

    computed: {
      currentScheme () {
        return this.route?.meta?.scheme || this.route.params?.scheme || '0';
      },
      isConfigureStep() {
        return this.route.name == 'Configure Vehicle';
      },
      isEcoAmapsOrderStep() {
        return this.routePath.includes("ecoamaps/order-process");
      },
      isSalarySacrificeOrderStep() {
        return this.routePath.includes("salsac/order-process");
      },
      isBchOrderStep() {
        return this.routePath.includes("bch/order-process");
      },
      isComparisonOrBeyond() {
        return this.route.name === 'Car Comparison'
          || this.isConfigureStep
          || this.isEcoAmapsOrderStep
          || this.isSalarySacrificeOrderStep
          || this.isBchOrderStep;
      }
    }
}

</script>
